import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, Input } from '@fluentui/react-components';

const isValidEmailAddress = (address) => {
  const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(address).toLowerCase());
};

const validateEmails = (emailString) => {
  if (!emailString) {
    return { valid: false, message: _TL_('Please enter at least one email address') };
  }

  const emails = emailString.split(';').map(email => email.trim()).filter(email => email);

  if (emails.length === 0) {
    return { valid: false, message: _TL_('Please enter at least one email address') };
  }

  if (emails.length > 5) {
    return { valid: false, message: _TL_('Exceed maximum 5 email addresses') };
  }

  const invalidEmails = emails.filter(email => !isValidEmailAddress(email));

  if (invalidEmails.length > 0) {
    return {
      valid: false,
      message: _TL_('Invalid email addresses: ') + invalidEmails.join(', '),
    };
  }

  return { valid: true, message: '' };
};

export const EmailInput = ({
  className,
  label,
  placeholder,
  hint,
  value,
  onChange,
}) => {
  const [validationState, setValidationState] = useState({ valid: true, message: '' });

  const handleChange = useCallback((e, data) => {
    const newValue = data.value;
    const validation = validateEmails(newValue);

    setValidationState(validation);
    onChange(newValue, validation);
  }, [onChange]);

  return (
    <Field
      className={className}
      label={label}
      hint={hint}
      validationMessage={validationState.message}
    >
      <Input
        type="email"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </Field>
  );
};

EmailInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

EmailInput.defaultProps = {
  className: '',
  label: '',
  placeholder: '',
  hint: '',
  value: '',
  onChange: _.noop,
};
